import { ChangeDetectionStrategy, Component, input, viewChild } from "@angular/core";
import { MenuItem } from "primeng/api";
import { Menu, MenuModule } from "primeng/menu";

@Component({
    selector: "kno2-menu",
    imports: [MenuModule],
    template: `
        <p-menu
            #menu
            [model]="model()"
            [popup]="true"
            [baseZIndex]="10000"
            appendTo="body" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuComponent {
    public readonly model = input<Array<MenuItem>>([]);
    private readonly menu = viewChild.required<Menu>("menu");

    public toggle(event: Event): void {
        this.menu().toggle(event);
    }
}
